import { render, staticRenderFns } from "./MigrationSPE.vue?vue&type=template&id=58b26849&"
import script from "./MigrationSPE.vue?vue&type=script&lang=js&"
export * from "./MigrationSPE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports